import React from 'react'
import DeployedData from "../DeployedData"
import "./PayloadSVG.scss"

function PayloadSVG({ allparts = [], parts, deployed }) {
    const paintParts = (needle) => {
        return parts && parts.find((part) => part.part === needle) ? "#E18B00" : "rgba(80,83,92,0.75)"
    }

    const showPartLine = (needle) =>{
        return parts.find((part) => part.part === needle)
    }
    const letterToIndex = (letter) =>  letter.charCodeAt(0) - 65;

    console.log(allparts, parts, allparts[letterToIndex('A')]?.name )


    return <div className={'payloadsvg-container'} >
    <svg xmlns="http://www.w3.org/2000/svg" width="255" height="415.436" viewBox="0 0 375 415.436">
        <g id="Group_132" data-name="Group 132" transform="translate(-66.17 463.658) rotate(-90)">
            <path id="Path_191" data-name="Path 191" d="M173.512,212.837H55.894a2.613,2.613,0,0,1-2.421-1.6c-1.389-3.329-4.251-11.908-4.251-26.115s2.862-22.786,4.251-26.115a2.613,2.613,0,0,1,2.421-1.6H173.512a2.632,2.632,0,0,1,2.632,2.632V210.2A2.632,2.632,0,0,1,173.512,212.837Z" transform="translate(0 18.378)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>
            <path id="Path_194" data-name="Path 194" d="M-10630.5,1795.939v-49.887" transform="translate(2209.71 10880.17) rotate(90)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
            <rect id="Rectangle_1483" data-name="Rectangle 1483" width="55.423" height="86.119" rx="1.973" transform="translate(176.144 160.444)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>
            <rect id="Rectangle_1486" data-name="Rectangle 1486" width="168.179" height="168.179" rx="2.027" transform="translate(254.919 119.414)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>
            <path id="Path_192" data-name="Path 192" d="M-10721.5,1908.574v10.61h37.961v57.177" transform="translate(2194.907 10880.17) rotate(90)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
            <path id="Path_193" data-name="Path 193" d="M-10683.539,1866.276v52.909h-37.961v57.177" transform="translate(2194.907 10932.209) rotate(90)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
            <rect id="Rectangle_1487" data-name="Rectangle 1487" width="61.977" height="40.826" rx="4.556" transform="translate(203.856 183.091)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>
            <rect id="Rectangle_1488" data-name="Rectangle 1488" width="84.397" height="40.826" rx="5.316" transform="translate(287.269 137.132)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>
            <rect id="Rectangle_1489" data-name="Rectangle 1489" width="84.397" height="40.826" rx="5.316" transform="translate(287.269 183.091)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>
            <rect id="Rectangle_1490" data-name="Rectangle 1490" width="84.397" height="40.826" rx="5.316" transform="translate(329.467 228.67)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>

            <rect id="A"
                data-name="Rectangle 1484"
                width="17.329"
                height="69.179"
                rx="3.667"
                transform="translate(158.441 169.595)"
                fill={paintParts("A")}
                stroke="#eee5e9"
                strokeMiterlimit="10"
                strokeWidth="2"/>

            <circle id="D"
                data-name="Ellipse 247"
                cx="15.138"
                cy="15.138"
                r="15.138"
                transform="translate(188.718 188.366)"
                fill={paintParts("B")}
                stroke="#eee5e9"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <ellipse id="B"
                data-name="Ellipse 250"
                cx="6.562"
                cy="25.214"
                rx="6.562"
                ry="25.214"
                transform="translate(74.404 178.29)"
                fill={paintParts("D")}
                stroke="#eee5e9"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <rect id="Rectangle_1485"
                data-name="Rectangle 1485"
                width="8.913"
                height="50.197"
                rx="2.24"
                transform="translate(176.144 178.405)"
                fill={paintParts("C")}
                strokeMiterlimit="10"
                strokeWidth="2"/>


            <ellipse id="Ellipse_248" data-name="Ellipse 248" cx="6.136" cy="21.962" rx="6.136" ry="21.962" transform="translate(106.547 181.542)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>
            <ellipse id="Ellipse_249" data-name="Ellipse 249" cx="6.562" cy="25.214" rx="6.562" ry="25.214" transform="translate(52.404 178.29)" fill="rgba(80,83,92,0.75)" stroke="#eee5e9" strokeMiterlimit="10" strokeWidth="2"/>
        </g>

            { showPartLine('A') &&
                <g>
                    <text id="letter_A" transform="translate(47 322.948)" fill="#78a1bb" fontSize="24" fontFamily="Rajdhani-Bold, Rajdhani" fontWeight="700"><tspan x="0" y="0">{allparts[letterToIndex('A')]?.name || 'Error in caption'}</tspan></text>
                    <line id="Line_198" data-name="Line 198" y1="19" x2="54" transform="translate(65.5 297.448)" fill="none" stroke="#0c95eb" strokeWidth="1"/>
                </g>
            }
            { showPartLine('B') &&
                <g>
                    <text id="letter_B" transform="translate(203 394.948)" fill="#78a1bb" fontSize="24" fontFamily="Rajdhani-Bold, Rajdhani" fontWeight="700"><tspan x="0" y="0">{allparts[letterToIndex('B')]?.name || ''}</tspan></text>
                    <line id="Line_199" data-name="Line 199" x1="59" transform="translate(137.5 388.448)" fill="none" stroke="#0c95eb" strokeWidth="1"/>
               </g>
            }
            { showPartLine('C') &&
                <g>
                    <text id="letter_C" transform="translate(227 290.948)" fill="#78a1bb" fontSize="24" fontFamily="Rajdhani-Bold, Rajdhani" fontWeight="700"><tspan x="0" y="0">{allparts[letterToIndex('C')]?.name || ''}</tspan></text>
                    <line id="Line_200" data-name="Line 200" x1="65" transform="translate(156.5 283.448)" fill="none" stroke="#0c95eb" strokeWidth="1"/>
                </g>
            }
            { showPartLine('D') &&
                <g>
                    <text id="letter_D" transform="translate(34 268.948)" fill="#78a1bb" fontSize="24" fontFamily="Rajdhani-Bold, Rajdhani" fontWeight="700"><tspan x="0" y="0">{allparts[letterToIndex('D')]?.name || ''}</tspan></text>
                    <line id="Line_201" data-name="Line 201" x1="75" transform="translate(56.5 261.948)" fill="none" stroke="#0c95eb" strokeWidth="1"/>
                </g>
            }
            { showPartLine('E') &&
                <g>
                    <text id="letter_E" transform="translate(0 148.948)" fill="#78a1bb" fontSize="24" fontFamily="Rajdhani-Bold, Rajdhani" fontWeight="700"><tspan x="0" y="0">{allparts[letterToIndex('E')]?.name || ''}</tspan></text>
                    <line id="Line_202" data-name="Line 202" x1="75" transform="translate(17.5 141.948)" fill="none" stroke="#0c95eb" strokeWidth="1"/>
                </g>
            }
            { showPartLine('F') &&
                <g>
                    <text id="letter_F" transform="translate(242 101.948)" fill="#78a1bb" fontSize="24" fontFamily="Rajdhani-Bold, Rajdhani" fontWeight="700"><tspan x="0" y="0">{allparts[letterToIndex('F')]?.name || ''}</tspan></text>
                    <line id="Line_203" data-name="Line 203" x1="96" transform="translate(137.5 154.948)" fill="none" stroke="#0c95eb" strokeWidth="1"/>
                </g>
            }
            { showPartLine('G') &&
                <g>
                    <text id="letter_G" transform="translate(241 163.948)" fill="#78a1bb" fontSize="24" fontFamily="Rajdhani-Bold, Rajdhani" fontWeight="700"><tspan x="0" y="0">{allparts[letterToIndex('G')]?.name || ''}</tspan></text>
                    <line id="Line_204" data-name="Line 204" x1="51" transform="translate(182.5 94.948)" fill="none" stroke="#0c95eb" strokeWidth="1"/>
                </g>
            }

    </svg>

        {/* <div>
            <DeployedData deployed={deployed} />
        </div> */}
   </div>
}

export default PayloadSVG;
